module.exports = __webpack_public_path__ + "img/dashboard.d484ea23.jpeg";